import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { moduleName } from '../../constants';
import { URI } from '../../constants/URI';
import { setOpenOrderId, setOrderItems } from '../slices/orderSlice';
import {
    appendProducts,
    setOpenOrderItems,
    setPagination,
    setPreferredProducts,
    setProducts,
    setRecentProducts,
    setSingleProduct
} from '../slices/productsSlice';
import { store } from '../store';

export const getProductsWithPagination = async ({
    body,
    isAppend = false,
    isDispatch = true,
    signal,
} = {}) => {
    const res = await handlePostRequest(URI.products, body, {
        module: moduleName.GET_PRODUCTS,
        loading: false,
        toast: false,
        signal,
    });

    if (res?.ack && isDispatch) {
        store.dispatch(setOpenOrderId(res?.open_order?.id || null));
        store.dispatch(setOrderItems(res?.open_order_items || []));
        store.dispatch(setOpenOrderItems(res?.open_order_items || []));

        isAppend
            ? store.dispatch(appendProducts(res.products))
            : store.dispatch(setProducts(res.products));
        const currentTotal = store.getState().productsSlice.pagination.total;
        const total = res?.total_count !== undefined ? res.total_count : currentTotal;

        store.dispatch(
            setPagination({
                page: body?.page || 1,
                total: total,
                totalPages: Math.ceil(total / 50),
            })
        );
    }

    return res;
};

export const getPublicProductsWithPagination = async ({
    body,
    isAppend = false,
    isDispatch = true,
} = {}) => {
    const res = await handlePostRequest(URI.public_products, body, {
        module: moduleName.GET_PRODUCTS,
        loading: false,
        toast: false,
    });

    if (res?.ack && isDispatch) {
        store.dispatch(setOpenOrderId(res?.open_order?.id || null));
        store.dispatch(setOrderItems(res?.open_order_items || []));
        isAppend
            ? store.dispatch(appendProducts(res.products))
            : store.dispatch(setProducts(res.products));
        const currentTotal = store.getState().productsSlice.pagination.total;
        const total = res?.total_count !== undefined ? res.total_count : currentTotal;

        store.dispatch(
            setPagination({
                page: body?.page || 1,
                total: total,
                totalPages: Math.ceil(total / 50),
            })
        );
    }

    return res;
};

export const getProducts = async () => {
    const res = await handleGetRequest(URI.all_products, null, {
        module: moduleName.GET_ALL_PRODUCTS,
    });

    return res;
};

export const getProductDetails = async ({ id, details, loading = true }) => {
    const res = await handleGetRequest(URI.product, null, {
        params: { id, details },
        loading,
    });

    if (res?.ack) {
        store.dispatch(setSingleProduct(res?.product?.at(0)));
    }

    return res;
};

export const addFavourite = async (body, filters) => {
    const res = await handlePostRequest(URI.favourite, body, {
        module: moduleName.FAVOURITE,
    });
    if (res?.ack)
        await getProductsWithPagination({
            body: {
                searchText: filters.searchText ?? '',
                customer_id: filters.customer_id ?? '',
                category: filters.category ?? [],
                favourite: filters.favourite ?? 0,
                recent: filters.recent ?? 0,
            },
        });

    return res;
};

export const removeFavourite = async (body, filters) => {
    const res = await handleDeleteRequest(URI.favourite, body, {
        module: moduleName.FAVOURITE,
    });
    if (res?.ack)
        await getProductsWithPagination({
            body: {
                searchText: filters.searchText ?? '',
                customer_id: filters.customer_id ?? '',
                category: filters.category ?? [],
                favourite: filters.favourite ?? 0,
                recent: filters.recent ?? 0,
            },
        });
    return res;
};

export const getRecentProducts = async (body, loading = true) => {
    const res = await handlePostRequest(URI.recent_products, body, {
        loading,
    });
    store.dispatch(setRecentProducts(res?.products || []));
    return res;
};

export const getPreferredProducts = async (body, loading = true) => {
    const res = await handlePostRequest(URI.preferred_products, body, {
        loading,
    });
    store.dispatch(setPreferredProducts(res?.products || []));
    return res;
};

export const syncProducts = async () => {
    const res = await handlePostRequest(URI.sync_products);
    return res;
};

export const getProductQuantities = async (body) => {
    const res = await handlePostRequest(URI.product_quantities, body, {
        loading: false,
    });
    return res;
};

export const addMaxQuantityRestriction = async (body) => {
    const res = await handlePostRequest(URI.product_quantity, body);
    return res;
}

export const updateMaxQuantityRestriction = async (body) => {
    const res = await handlePutRequest(URI.product_quantity, body);
    return res;
}

export const deleteMaxQuantityRestriction = async (body) => {
    const res = await handleDeleteRequest(URI.product_quantity, body);
    return res;
}


export const getProductActivity = async (body) => {
    const res = await handlePostRequest(URI.product_activity, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const getProductActivityDetails = async (body) => {
    const res = await handlePostRequest(URI.product_activity_details, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const scanProduct = async (body) => {
    const res = await handlePostRequest(URI.scan_product, body, {
        toast: false
    })
    return res;
}